import { all, fork, takeLatest } from 'redux-saga/effects';
import { fetchTable } from '../helpers/sagaHelpers';

function* watchFetchFinishedRequestsTable() {
  yield takeLatest('finishedRequests/fetchTable', fetchTable);
}

export default function* rootSaga() {
  yield all([fork(watchFetchFinishedRequestsTable)]);
}
